var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_12)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.706 16.006L6.23148 18.4806C5.20559 19.5064 3.54424 19.5064 2.51921 18.4808C1.49398 17.4555 1.49398 15.794 2.51901 14.769L7.46892 9.81908C8.49395 8.79401 10.1555 8.79401 11.1805 9.81908C11.5222 10.1608 12.0762 10.1608 12.4179 9.81908C12.7596 9.47738 12.7596 8.92334 12.4179 8.58163C10.7095 6.87316 7.93995 6.87316 6.23148 8.58163L1.2816 13.5315C-0.426875 15.24 -0.426875 18.0095 1.2816 19.718C2.98987 21.4273 5.75959 21.4273 7.46897 19.718L9.94349 17.2434C10.2852 16.9017 10.2852 16.3477 9.94349 16.006C9.60179 15.6643 9.04771 15.6643 8.706 16.006Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7184 1.28134C18.0099 -0.427134 15.2395 -0.427134 13.531 1.28134L10.5621 4.25023C10.2204 4.59193 10.2204 5.14598 10.5621 5.48768C10.9038 5.82938 11.4579 5.82938 11.7996 5.48768L14.7685 2.51879C15.7935 1.49372 17.4559 1.49372 18.4809 2.51879C19.506 3.54382 19.506 5.20533 18.4809 6.23035L13.0366 11.6747C12.0116 12.6997 10.3501 12.6997 9.32508 11.6747C8.98338 11.333 8.42934 11.333 8.08764 11.6747C7.74593 12.0164 7.74593 12.5704 8.08764 12.9121C9.79611 14.6206 12.5656 14.6206 14.2741 12.9121L19.7184 7.46784C21.4268 5.75937 21.4268 2.98981 19.7184 1.28134Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_12"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.a686bb04ccd261c003e9d1401f62d1cf.svg";
export { ForwardRef as ReactComponent };